import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {size} from '@acng/frontend-bounty/std/array.js';
/**
 * @import {Amateur} from '../../amateurPool/model/amateur.js';
 */
import {Actor} from '../../layout/context/list.js';
import {STYLE_EMPTY, swapClass} from '../../layout/service/style.js';
import {inject} from '../../core/service/ng.js';
import {getClosestImageFormat} from '../../core/service/image.js';
import {AmateurUpgrade, CreatorTemplateConfig} from '../service/template.js';
import {getAmateurVisits} from '../service/profile-visit.js';
import {get} from '../service/cache.js';

/**
 * @group DOM Attribute
 */
const name = 'amateur-list';

AttributeSetup(name, () => {
  const DEFAULT_IMAGE_FORMAT = '800';
  const provideList = Actor();

  /**
   * @param {Element} element
   * @param {string} type
   *
   * @returns {Promise<Amateur['id'][]>}
   */
  const getList = async (element, type) => {
    if (type == 'visits') {
      return getAmateurVisits();
    }

    // @ts-ignore Won't annotate deprecated AmateurFilter
    return inject('AmateurFilter').get(type).list(20000);
  };

  AttributeLink(name, (element, value) => {
    const format = getClosestImageFormat(element) ?? DEFAULT_IMAGE_FORMAT;

    provideList(
      element,
      async (offset) => {
        if (offset) {
          return [];
        }

        const list = await getList(element, value);
        swapClass(element, STYLE_EMPTY, !size(list));

        return list;
      },
      async (id) => {
        const amateur = await get(id);

        return AmateurUpgrade(amateur, CreatorTemplateConfig(amateur, format));
      },
    );
  });
});

export {name as AMATEUR_LIST};
